enum DashboardEntryComponentEnum {
    SHIP_TO = "SHIP_TO",
    DETAILS = "DETAILS",
    PANASONIC_RESELLER = "PANASONIC_RESELLER",
    PANASONIC_END_USER = "PANASONIC_END_USER",
    PANASONIC_DELIVERY_INFO = "PANASONIC_DELIVERY_INFO",
    PANASONIC_PROJECT_INFO = "PANASONIC_PROJECT_INFO",
}

export default DashboardEntryComponentEnum;
